import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { Form, Alert, Col, Button, Row, ButtonGroup } from 'react-bootstrap';
import { CodingEventService } from '../../services'
import { useImmer } from 'use-immer';
import { AuthContext } from '../../contexts/AuthContext';
import CustomerCodingEventService from '../../services/CustomerCodingEventService';


const CodingEventFileUpload = (props) => {
    const [name, setName] = useImmer('');
    const [error, setError] = useImmer('');
    const [selectedFile, setSelectedFile] = useImmer({ name: 'Select file' });
    const [codingEventService, setCodingEventService] = useImmer();

    const authContext = useContext(AuthContext);

    useEffect(() => {
        const accountId = parseInt(authContext.getClaims(authContext.claims.accountId));

        if (accountId > 1) {
            setCodingEventService(new CustomerCodingEventService);
        } else if (accountId == 1) {
            setCodingEventService(new CodingEventService());
        }
    }, []);

    const handleImportSelection = (event) => {
        let files = event.target.files;

        if (files && files.length > 0) {            
            setSelectedFile(files[0])
        }
        else {
            console.log("no files selected");
        }
    }

    const handleSave = async () => {
        // Create an object of formData 
        const formData = new FormData();

        // Update the formData object 
        if (selectedFile.name !== 'Select file') {
            formData.append(
                "file",
                selectedFile,
                selectedFile.name
            );

            formData.append(
                "codingEventId", props.codingEventId
            );
            formData.append(
                "name", name != '' ? name : selectedFile.name
            );
            var callResult = await codingEventService.createFile(formData);
            if (callResult.result) {
                props.fileUploaded(callResult.model);
            } else {
                setError('Error');
            }
        }
        else {
            setError('Invalid file');
        }

    }

    return (
        <div style={{ padding: "6px" }}>
            <Form.Row>
                <Form.Group as={Col} lg="5" md="12">
                    <Form.Label>Name</Form.Label>
                    <Form.Control placeholder="" name="name" id="name" value={name} onChange={(e) => setName(e.target.value)} />
                </Form.Group>
                <Form.Group as={Col} lg="5" md="12">
                    <Form.Label>Choose file to upload</Form.Label>
                    <Form.File
                        id="custom-file"
                        label={selectedFile.name}
                        onChange={(e) => handleImportSelection(e)}
                        custom />
                </Form.Group>
                <Form.Group as={Col}>
                    <Form.Label className="float-right">&nbsp;</Form.Label><br />
                    <ButtonGroup className="float-right mt-auto">
                        <Button variant="secondary" size="sm" onClick={props.close}>Cancel</Button>&nbsp;
                            <Button size="sm" onClick={() => handleSave()}>Upload</Button>
                    </ButtonGroup>
                </Form.Group>
            </Form.Row>
            {
                error !== "" ?
                    <Row><Col>
                        <Alert variant="error">{error}</Alert>
                    </Col></Row> : null
            }
        </div>
    );

    CodingEventFileUpload.defaultProps = {
        children: PropTypes.instanceOf(Array).isRequired
    };

}

export default CodingEventFileUpload;

//export default class CodingEventFileUpload2 extends Component {
//    static propTypes = {
//        children: PropTypes.instanceOf(Array).isRequired,
//    }

//    constructor(props) {
//        super(props);

//        this.state = {
//            name: '',
//            error: '',
//            selectedFile: { name: "Select file" },
//        };

//        this.handleUserInput = this.handleUserInput.bind(this);
//        this.handleSave = this.handleSave.bind(this);
//        this.handleImportSelection = this.handleImportSelection.bind(this);
//    }

//    componentDidMount() {
//        //this.setState();
//    }

//    handleImportSelection(event) {
//        //event.preventDefault();
//        let files = event.target.files;

//        if (files && files.length > 0) {
//            this.setState({ selectedFile: files[0] });
//        }
//        else
//            console.log("no files selected");
//    }

//    handleUserInput(event) {
//        // taken straight from the React Docs
//        // https://reactjs.org/docs/forms.html#handling-multiple-inputs
//        const target = event.target;
//        const value = target.type === 'checkbox' ? target.checked : target.value;
//        const name = target.name;
//        //var partialState = { ...this.state };
//        //partialState[name] = value;
//        this.setState({ name: value });
//    }

//    async handleSave() {
//        var codingEventService = new CodingEventService();
//        // Create an object of formData 
//        const formData = new FormData();

//        // Update the formData object 
//        if (this.state.selectedFile.name !== 'Select file') {
//            formData.append(
//                "file",
//                this.state.selectedFile,
//                this.state.selectedFile.name
//            );

//            formData.append(
//                "codingEventId", this.props.codingEventId
//            );
//            formData.append(
//                "name", this.state.name
//            );
//            var callResult = await codingEventService.createFile(formData);
//            if (callResult.result) {
//                this.props.fileUploaded(callResult.model);
//            } else {
//                this.setState({ error: "Error!" });
//            }
//        }
//        else {
//            this.setState({ error: "Invalid file" });
//        }

//    }

//    render() {


//        return (
//            <div style={{padding: "6px"}}>
//                <Form.Row>
//                    <Form.Group as={Col} lg="5" md="12">
//                        <Form.Label>Name</Form.Label>
//                        <Form.Control placeholder="" name="name" id="name" value={this.state.name} onChange={this.handleUserInput} />
//                    </Form.Group>
//                    <Form.Group as={Col} lg="5" md="12">
//                        <Form.Label>Choose file to upload</Form.Label>
//                        <Form.File
//                            id="custom-file"
//                            label={this.state.selectedFile.name}
//                            onChange={(e) => this.handleImportSelection(e)}
//                            custom />
//                    </Form.Group>
//                    <Form.Group as={Col}>
//                        <Form.Label className="float-right">&nbsp;</Form.Label><br/>
//                        <ButtonGroup className="float-right mt-auto">
//                            <Button variant="secondary" size="sm" onClick={this.props.close}>Cancel</Button>&nbsp;
//                            <Button size="sm" onClick={() => this.handleSave()}>Upload</Button>
//                        </ButtonGroup>
//                    </Form.Group>
//                </Form.Row>
//                {
//                    this.state.error !== "" ?
//                        <Row><Col>
//                            <Alert variant="error">{this.state.error}</Alert> 
//                        </Col></Row>: null
//                    }
//            </div>
//        );
//    }
//}